/*
 * Custom PDP — Global helpers
 * Loaded from theme.liquid <head> so it runs reliably on every page,
 * even when section <script> blocks fail to render.
 *
 * Currently handles:
 *   - Orphan repatriation: if malformed HTML in a custom-liquid block (stray
 *     </form>, extra </div>) caused trailing .cpm-block / .cpm-sticky-atc
 *     elements to land outside .cpm-info as flex siblings of .cpm-grid, this
 *     finds them and moves them back into .cpm-info.
 *   - LB accordion (legacy lb-accordion-header / lb-accordion-content) click
 *     toggle, in case the original inline JS for it didn't load.
 */
(function() {
  'use strict';

  function repatriateOrphans() {
    document.querySelectorAll('.cpm-grid').forEach(function(grid) {
      var info = grid.querySelector(':scope > .cpm-info');
      if (!info) return;
      Array.prototype.slice.call(grid.children).forEach(function(child) {
        if (child === info) return;
        if (child.classList.contains('cpm-gallery')) return;
        // Don't move <input> elements — they may be Shopify form internals
        // (product-id, section-id) that need to stay inside the <form>.
        if (
          child.classList.contains('cpm-block') ||
          child.classList.contains('cpm-sticky-atc')
        ) {
          info.appendChild(child);
        }
      });
    });
  }

  function bindLbAccordions() {
    document.querySelectorAll('.custom-pdp-main .lb-accordion-header').forEach(function(btn) {
      if (btn.dataset.cpdpBound) return;
      btn.dataset.cpdpBound = '1';
      btn.addEventListener('click', function() {
        var item = btn.closest('.lb-accordion-item');
        if (!item) return;
        var isOpen = item.classList.toggle('is-open');
        var icon = btn.querySelector('.lb-accordion-icon');
        if (icon) icon.textContent = isOpen ? '\u2212' : '+';
      });
    });
  }

  /*
   * Mobile-only "scrolled" class on <body>.
   * The Empire theme's _toggleStickyHeader early-returns on mobile, so
   * .site-header-sticky--scrolled is never added below the M breakpoint.
   * That means CSS rules that hide elements on scroll (like the small-promo
   * contact strip) have nothing to hook onto. This adds our own class —
   * .lb-mobile-scrolled — to <body> when scroll position > 4px on mobile,
   * removes it at the top. Passive listener so it doesn't block scrolling.
   */
  function bindMobileScrollClass() {
    var body = document.body;
    var ticking = false;
    /* Hysteresis thresholds: add the class once we've scrolled past 12px,
       only remove once we're back within 2px of the top. Prevents flicker
       from micro-scrolls right at the threshold. */
    var ON_AT = 12;
    var OFF_AT = 2;
    function update() {
      var isMobile = window.matchMedia('(max-width: 1023px)').matches;
      if (!isMobile) {
        body.classList.remove('lb-mobile-scrolled');
        ticking = false;
        return;
      }
      var y = window.scrollY;
      var has = body.classList.contains('lb-mobile-scrolled');
      if (!has && y > ON_AT) body.classList.add('lb-mobile-scrolled');
      else if (has && y < OFF_AT) body.classList.remove('lb-mobile-scrolled');
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init() {
    repatriateOrphans();
    bindLbAccordions();
    bindMobileScrollClass();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on Shopify theme editor section reloads
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:reorder', init);
  }
})();
